import { Ladespinner } from "../../../../node_modules/thalia-molecules/modules";
import { render } from "../../assets/js/dom";
import { validateTextResponse } from "../../assets/js/fetch";

class ContentLoader extends HTMLElement {
    constructor() {
        super();
        if (this.url) {
            this.ladespinner = new Ladespinner(this, false);
            this.ladespinner.render();
            this.initObserver();
        }
    }

    get url() {
        return this.dataset["url"]
    }

    initObserver() {
        const observer = new IntersectionObserver(this.intersectionCallback.bind(this));
        observer.observe(this);
    }

    intersectionCallback(entries, observer) {
        const bereitsGeladen = !!this.querySelector("[component]");
        if (bereitsGeladen) {
            return;
        }
        for (const entry of entries) {
            if (entry.isIntersecting) {
                observer.disconnect();
                this.loadContent();
            }
        }
    }

    async loadContent() {
        try {
            this.ladespinner.show();
            const result = await fetch(this.url);
            const html = await result.text();
            const validTextResponse = validateTextResponse(html);
            if (validTextResponse) {
                return render(this, html);
            }
            // Nichts machen, wenn Response nicht valid ist
        } catch (error) {
            console.error("loadContent");
            console.error(error);
        } finally {
            this.ladespinner.hide();
        }
    }
}

if (!customElements.get("content-loader")) {
    customElements.define("content-loader", ContentLoader);
}
